import { DEAL_MANAGER_STATE_ID, DealManagerState } from 'scenes/Dashboard/scenes/DealManager/duck/types'

import {
  ORGANIZATION_DETAILS_MODAL_STORE_ID,
  OrganizationDetailsModalState,
} from '../components/OrganizationDetailsModal/duck/types'
import { DashboardDataState } from '../data/types'
import { ORGANIZATIONS_MANAGER_STORE_ID, OrganizationsManagerState } from '../scenes/OrganizationsManager/duck/types'
import { PEOPLE_MANAGER_STORE_ID, PeopleManagerState } from '../scenes/PeopleManager/duck/types'

export type DashboardState = {
  readonly data: DashboardDataState
  readonly components: {
    readonly [ORGANIZATION_DETAILS_MODAL_STORE_ID]: OrganizationDetailsModalState
  }
  readonly scenes: {
    readonly [ORGANIZATIONS_MANAGER_STORE_ID]: OrganizationsManagerState
    readonly [PEOPLE_MANAGER_STORE_ID]: PeopleManagerState
    readonly [DEAL_MANAGER_STATE_ID]: DealManagerState
  }
}

export const DASHBOARD_STORE_ID = 'Dashboard'
